// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function cluster_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var zone_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "zone_id"), null));
      if (zone_id.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  name: name._0,
                  zone_id: zone_id._0
                }
              };
      }
      var e = zone_id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".zone_id" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var clusters = Decco.listFromJson(cluster_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "clusters"), null));
  if (clusters.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              clusters: clusters._0
            }
          };
  }
  var e = clusters._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".clusters" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  cluster_decode ,
  t_decode ,
  
}
/* No side effect */
